import { Button, Heading, Text, VStack } from '@chakra-ui/react';
import Modal from 'react-modal';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { add_to_cart } from 'redux/actions/productActions';

const AddToCartModal = ({ isModalOpen, closeModal, currentItem, quantity }) => {
    const dispatch = useDispatch();

    let item = JSON.parse(localStorage.getItem('store_cart_items'));
    let items = item ? [...item, currentItem] : [currentItem];
    const addProdToCart = async () => {
        localStorage.setItem('store_cart_items', JSON.stringify(items));
        let data = {
            productId: currentItem?.item_id,
            qty: Number(quantity?.value) || 1,
        };
        closeModal();
        dispatch(add_to_cart(data));
    };
    return (
        <Modal
            isOpen={isModalOpen}
            onRequestClose={() => closeModal()}
            className="Modal"
            overlayClassName="Overlay">
            <Container>
                <Heading as="h4" textAlign="center" fontSize="24px" mt="25px">
                    Push to Cart
                </Heading>
                <Text fontSize="16px" textAlign="center" mt="25px">
                    Are you sure want Move this Product to Cart Items{' '}
                </Text>
                <VStack mt="20px">
                    <Button
                        w="100%"
                        color="#F5F5F5"
                        bg="#1b3b5f"
                        mt="15px"
                        fontWeight="400"
                        borderRadius="48px"
                        h="48px"
                        outline="none"
                        onClick={addProdToCart}>
                        {'Confirm'}
                    </Button>
                    <Button
                        w="100%"
                        color="#202325"
                        bg="white"
                        mt="15px"
                        fontWeight="400"
                        borderRadius="48px"
                        outline="none"
                        onClick={() => {
                            closeModal();
                        }}>
                        Cancel
                    </Button>
                </VStack>
            </Container>
        </Modal>
    );
};

export default AddToCartModal;
const Container = styled.div`
    width: 380px;
    max-height: 100%;
    background: #ffffff;
    border-radius: 16px 16px 16px 16px;
    padding: 24px 24px;
    padding-bottom: 50px;

    @media screen and (max-width: 500px) {
        padding: 18px 18px;
        width: 100vw;
        max-height: 100%;
        background: #ffffff;
        border-radius: 16px 16px 0px 0px;
    }
    a {
        width: 95%;
        border-radius: 5px;
        padding: 4px;
        height: 44px;
        font-size: 20px;
    }
    .active-link {
        background: rgba(33, 33, 241, 0.1);
        color: #1b3b5f;
        font-weight: 700;
        svg {
            path {
                stroke: #1b3b5f;
            }
        }
    }
`;
